import { Calendar } from 'primereact/calendar';
import { useContext, useEffect, useState } from 'react';
import { AddressContext } from '../contexts/AddressContext';
import { WishValidatorContext } from '../contexts/WishValidatorContext';
import { Checkbox } from 'primereact/checkbox';

export const CheckKidSibling = ({ advantage, index, formData, handleChange, wish, advIndex, isEdit, cleanSiblingInputFields, onBlurWishHandler }) => {
    const { siblingIsValid, cleanSiblingErrors } = useContext(AddressContext);
    const { wishErrors, removeError } = useContext(WishValidatorContext);
    const [showFields, setShowFields] = useState(isEdit && formData.wishes[index][`${advantage.code}_NAME`] ? true : false);

    useEffect(() => {
        if (formData.wishes[index][`${advantage.code}_NAME`] == '' && formData.wishes[index][`${advantage.code}_EGN`] == '') {
            cleanSiblingErrors(index, advantage.code)
        }
    }, [formData])

    const toggleFields = (e) => {
        if (showFields) {
            cleanSiblingInputFields(e, index, advantage.code)
            removeError(e, index, advantage.code)
        }
        setShowFields(!showFields)
    }

    return (
        <div className="d-flex flex-wrap w-100 rounded gap-4 adv-checkbox px-4 py-2 justify-content-between p-3-mob">
            <label className="w-84">{advantage.name}</label>
            <div className="d-flex w-100-mob">
                <Checkbox
                    name='showFields'
                    onChange={toggleFields}
                    checked={showFields}
                />
                &nbsp;&nbsp;Да
            </div>
            {showFields &&
                <>
                <div className="labels_rb w-48 d-flex flex-col flex-wrap justify-content-between fade flex-col-mob w-100-mob" id="basic-addon1">
                        <div className="w-75">
                            ЕГН*
                            <input
                                type="checkbox"
                                id="lnccid"
                                name={`${advantage.code}_IsEgn`}
                                value="1"
                                checked={wish[`${advantage.code}_IsEgn`] == '1'}
                                onChange={(e) => handleChange(e, index, advantage.code)}
                                defaultChecked
                            />
                            &nbsp;&nbsp;&nbsp;ЛНЧ*
                            <input
                                type="checkbox"
                                id="lnccid"
                                name={`${advantage.code}_IsEgn`}
                                value="0"
                                checked={wish[`${advantage.code}_IsEgn`] == '0'}
                                onChange={(e) => handleChange(e, index, advantage.code)}
                            />
                        </div>
                    <div className="d-flex  w-100 gap-2 flex-col-mob">

                            {wish[`${advantage.code}_IsEgn`] == 0 ?
                                <>
                                    <input
                                        className={`form-control fade round_buttons w-100`}
                                        name={`${advantage.code}_EGN`}
                                        value={formData.wishes[index][`${advantage.code}_EGN`]}
                                        onChange={(e) => handleChange(e, index)}
                                        onBlur={(e) => onBlurWishHandler(e, index, advantage.code)}
                                        placeholder={wish[`${advantage.code}_IsEgn`] == '1' ? 'ЕГН на дете' : 'ЛНЧ на дете'}
                                    />
                                    <Calendar
                                        showButtonBar
                                        locale='bg'
                                        className="fade prime-dropdown-heigth w-100"
                                        name={`${advantage.code}_LnchDate`}
                                        value={formData.wishes[index][`${advantage.code}_LnchDate`] || null}
                                        onChange={(e) => handleChange(e, index)}
                                        showIcon
                                        placeholder='Дата на раждане'
                                    />
                                </>
                                : <input
                                    className={`${!siblingIsValid[`${advantage.code}Error`] && formData.wishes[index][`${advantage.code}_EGN`] && formData.wishes[index][`${advantage.code}_EGN`].length == 10 ? 'border border-success' : 'border border-danger'} form-control fade round_buttons w-100`}
                                    name={`${advantage.code}_EGN`}
                                    value={formData.wishes[index][`${advantage.code}_EGN`]}
                                    onChange={(e) => handleChange(e, index)}
                                    onBlur={(e) => onBlurWishHandler(e, index, advantage.code)}
                                    placeholder={wish[`${advantage.code}_IsEgn`] == '1' ? 'ЕГН на дете' : 'ЛНЧ на дете'}
                                />
                            }

                        </div>
                    </div>
                <div className="labels_rb d-flex w-45 flex-col flex-wrap justify-content-between fade w-100-mob" id="basic-addon1">
                        <label className="w-84">Три имена*</label>
                        <input
                            className={`${!siblingIsValid[`${advantage.code}Error`] && formData.wishes[index][`${advantage.code}_NAME`] ? 'border border-success' : 'border border-danger'} form-control round_buttons w-100`}
                            name={`${advantage.code}_NAME`}
                            value={formData.wishes[index][`${advantage.code}_NAME`]}
                            onChange={(e) => handleChange(e, index)}
                            onBlur={(e) => onBlurWishHandler(e, index, advantage.code)}
                        />
                    </div>
                </>
            }

            {siblingIsValid[`${index}${advantage.code}Error`] && <label className="text-danger w-100 ">{siblingIsValid[`${index}${advantage.code}Error`]}</label>}
            {wishErrors[`${index}${advantage.code}`] && <label className="text-danger w-100 ">{wishErrors[`${index}${advantage.code}`]}</label>}
        </div>
    )
}